// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1WI3S","errorLogs":"EditorFooter_errorLogs__1rOUg"};